import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import type { AssistTarget } from "./assist-target";
import type { guideContext } from "./guide-context";

/** Same instructions for page/sidebar; Assist navigates/focuses only, never decides. */
export function SyntheticReceiptGuide({
  scope,
  context,
  onShowStep,
  onContextValidation,
}: {
  scope: string | null;
  context: ReturnType<typeof guideContext>;
  onShowStep?: (to: string, target: AssistTarget, context: ReturnType<typeof guideContext>) => void;
  onContextValidation?: (valid: boolean) => void;
}) {
  const { t } = useTranslation();
  useEffect(() => onContextValidation?.(!!scope), [scope, onContextValidation]);
  const button =
    "min-h-11 rounded border border-slate-300 px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-brand-500";
  return (
    <section className="min-w-0 space-y-4" aria-label={t("guide.title")}>
      <h3 className="text-lg font-semibold">{t("email_sandbox.guide_title")}</h3>
      {!scope && <p role="status">{t("guide.choose_firm")}</p>}
      <ol className="list-decimal space-y-3 pl-5">
        {(t("email_sandbox.guide_steps", { returnObjects: true }) as string[]).map(
          (step, index) => (
            <li key={index}>{step}</li>
          ),
        )}
      </ol>
      {scope &&
        (onShowStep ? (
          <button
            type="button"
            className={button}
            onClick={() => onShowStep("/email-receipts", "synthetic-receipts", context)}
          >
            {t("email_sandbox.guide_show")}
          </button>
        ) : (
          <Link className={button} to="/email-receipts">
            {t("email_sandbox.guide_show")}
          </Link>
        ))}
      <p className="text-xs text-slate-500">{t("guide.no_effect")}</p>
    </section>
  );
}
